import { SIDE_NAV_LIGHT, NAV_TYPE_SIDE, DIR_LTR } from '../constants/ThemeConstant';
import { env } from './EnvironmentConfig'

export const APP_NAME = 'CIP';
export const API_BASE_URL = env.KC_ENDPOINT_URL
export const APP_PREFIX_PATH = '/cip';
export const AUTH_PREFIX_PATH = '/auth';
export const DEFAULT_PREFIX_VIEW = '/experience';

export const THEME_CONFIG = {
	navCollapsed: false,
	sideNavTheme: SIDE_NAV_LIGHT,
	locale: 'en',
	navType: NAV_TYPE_SIDE,
	topNavColor: '#3e82f7',
	headerNavColor: '',
	mobileNav: false,
	currentTheme: 'light',
	direction: DIR_LTR,
	subNavColor:'#3CA292'
};

